import type { Nullable } from 'corgi-types';
import { ArticleImageFormat, type GQLLocale, type ReclamationUpdateBatch } from 'graphql-ts-types';

import { executeQuery } from 'common/gql';
import type {
  UpdateReclamationMutation,
  UpdateReclamationMutationVariables,
} from 'common/gql/generated/schema';
import isWebpSupported from 'common/utils/isWebpSupported';
import type { ReclamationItem, StepOptions } from '../gql/mutation/types';
import updateReclamationMutation from '../gql/mutation/updateReclamation.gql';

interface GetUpdateReclamationVariablesParams extends Omit<ReclamationUpdateBatch, 'lineNumbers'> {
  reclamationId: string;
  itemId: string;
  locale: GQLLocale;
}

export const getStepOptionsByItemId = (
  items: Array<Nullable<ReclamationItem>>,
  itemId: string
): StepOptions => ({
  data: (items.find(item => item?.id === itemId) ?? {}) as ReclamationItem,
});

export const getUpdateReclamationVariables = ({
  reclamationId,
  itemId,
  reason,
  solution,
  partNumbers,
  comment,
  vendorOrderId,
  locale,
}: GetUpdateReclamationVariablesParams): Pick<
  UpdateReclamationMutationVariables,
  'locale' | 'reclamationId' | 'updateBatches'
> => ({
  locale,
  reclamationId,
  updateBatches: [
    {
      id: itemId,
      ...(reason && { reason }),
      ...(solution && { solution }),
      ...(partNumbers && { partNumbers }),
      ...(comment && { comment }),
      ...(vendorOrderId && { vendorOrderId }),
    },
  ],
});

export const updateReclamation = (
  variables: Omit<UpdateReclamationMutationVariables, 'imageFormat'>
) =>
  executeQuery<UpdateReclamationMutation, UpdateReclamationMutationVariables>({
    query: updateReclamationMutation,
    variables: {
      ...(isWebpSupported() && { imageFormat: ArticleImageFormat.Webp }),
      ...variables,
    },
    useApq: true,
  });
